import context from '../context';
import {
  SHIFT_TYPES,
  CALENDAR_GROUP_CATEGORIES,
  OTHER_DAY_PART_FILTER_OPTION_ID,
} from '../constants';
import belongsToDayPart from './belongsToDayPart';
import shouldBeInOtherDayPartRow from './shouldBeInOtherDayPartRow';

export default function isFromForeignGroup(event, user, group) {
  if (
    !group ||
    !user ||
    !SHIFT_TYPES.includes(event.type) ||
    /^(unassigned|available)$/.test(group.key)
  ) {
    return false;
  }

  const personaUser = user && context.personasDict[user.id];
  const personaGroup = context.personasDict[group.key];

  if (event.hiddenByFilters) {
    return true;
  }

  if (group.category === CALENDAR_GROUP_CATEGORIES.TAGS) {
    if (!context.tagFeatureEnabled) {
      return false;
    }

    const tag = context.tags.find((t) => t.id === group.key);
    return tag ? !event.tags.find((t) => t.id === tag.id) : false;
  } else if (group.category === CALENDAR_GROUP_CATEGORIES.DAY_PARTS) {
    if (!context.dayPartsFeatureEnabled) {
      return false;
    }

    if (group.type === OTHER_DAY_PART_FILTER_OPTION_ID) {
      return !shouldBeInOtherDayPartRow(event);
    }

    const dayPart = context.dayParts.find((dp) => dp.id === group.key);
    return dayPart ? !belongsToDayPart(event, dayPart) : false;
  }

  if (!personaGroup) {
    return false;
  }

  if (personaGroup.type === 'group') {
    return personaUser && !personaUser.groupIds.includes(personaGroup.id);
  }

  return event[personaGroup.type].id !== personaGroup.id;
}
